"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isErrorWithMessage = isErrorWithMessage;
exports.isAWSError = isAWSError;
exports.toErrorWithMessage = toErrorWithMessage;
/**
 * Type guard to check if error has message property
 */
function isErrorWithMessage(error) {
    return (typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        // Justified coercion: narrowing unknown error to access 'message' after confirming it exists via 'in' check
        typeof error.message === 'string');
}
/**
 * Type guard to check if error is AWS SDK error
 */
function isAWSError(error) {
    // Justified coercion: narrowing unknown error to access 'name' after confirming it exists via 'in' check
    return isErrorWithMessage(error) && 'name' in error && typeof error.name === 'string';
}
/**
 * Convert unknown error to ErrorWithMessage
 * Falls back to generic message if error doesn't have message property
 */
function toErrorWithMessage(error) {
    if (isErrorWithMessage(error))
        return error;
    try {
        return { message: JSON.stringify(error) };
    }
    catch {
        return { message: String(error) };
    }
}
